{
  "separatorName": "SEPARATOR",
  "GUEST_AVATAR_PATH": "/build/images/guest-avatar.svg",
  "FAVORITES_SELECTOR": "#navbar__favorites .ds-header__navbar__nav__link__pill",
  "ENQUIRIES_SELECTOR": "#navbar__enquiries .ds-header__navbar__nav__link__pill",
  "MAX_HEADER_HEIGHT_MOBILE": 56,
  "links": [
    {
      "name": "settings",
      "url": "/venue-cabinet/company-details",
      "label": "Settings",
      "options": {
        "icon": "settings",
        "tracking": {
          "section": "navbar_manager",
          "element": "settings"
        }
      }
    },
    {
      "name": "account",
      "url": "/venue-cabinet/my-account",
      "label": "My account",
      "options": {
        "icon": "myAccount",
        "tracking": {
          "section": "navbar_manager",
          "element": "my_account"
        }
      }
    },
    {
      "name": "help",
      "url": "/help/venue-faq",
      "label": "Help Centre",
      "options": {
        "icon": "info",
        "tracking": {
          "section": "navbar_manager",
          "element": "help_centre"
        }
      }
    },
    {
      "name": "logout",
      "url": "/venue-cabinet/logout",
      "label": "Log out",
      "options": {
        "icon": "logout",
        "onclick": [
          "publishLogoutEvent"
        ],
        "tracking": {
          "section": "navbar_manager",
          "element": "log_out"
        }
      }
    }
  ]
}